export const VNSTAND_TRUNCATED_STAND_FROM_MENU = 'VNSTAND_TRUNCATED_STAND_FROM_MENU'
